'use client'

import { useMemo } from 'react'

import cn from 'classnames'

import Calculator from 'components/ui/calculator'
import { useAppSelector } from 'store/hooks'
import { getCurrencies } from 'store/reducers/currencies'

import { useTranslation } from 'utils/use-translation'

import { useFloatingTrustpilot } from 'utils/use-trustpilot-widget'

import styles from './styles.module.scss'
import TabsSlider from 'components/ui/tabs-slider'

import { useRouter } from 'next/router'
import MobileAppBtn from 'components/global/mobile-app-link'

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element) => void
    }
  }
}

const tabs = ['loan', 'trade', 'earn']

export default function MainBlock() {
  const { t } = useTranslation()
  const router = useRouter()

  const currencies = useAppSelector(getCurrencies)

  useFloatingTrustpilot('trustpilot-target')

  const currenciesCount = useMemo(() => {
    const count = currencies?.filter((el) => el.is_loan_deposit_enabled || el.is_loan_receive_enabled).length

    return count ? `${count}+` : ''
  }, [currencies])

  const handleTabChange = (tab: string) => {
    switch (tab) {
      case 'trade': {
        router.push('/exchange')
        return
      }
      case 'earn': {
        router.push('earn')
        return
      }
    }
  }

  return (
    <section className={styles.container}>
      <div className={styles['main-block']}>
        <div className={cn('container', styles['main-block__wrapper'])}>
          <div className={styles['description-header__tablet']}>
            <TabsSlider
              tabs={tabs}
              activeTab={tabs[0]}
              handleTabChange={handleTabChange}
              className={styles['desktop-only']}
            />

            <p className={styles.title}>{t('crypto_loans')}</p>
            <p className={styles.subtitle} dangerouslySetInnerHTML={{
              __html: t('get_instant_funds_against_your_crypto')
            }}></p>
            <div className={styles['subtitle-text']}>
              <p>{t('access_extra_funds_without_selling_crypto')}</p>
              <p>{t('grow_portfolio')}</p>
            </div>
          </div>

          <div className={styles.description}>
            <div className={styles['description-header']}>
              <TabsSlider
                tabs={tabs}
                activeTab={tabs[0]}
                handleTabChange={handleTabChange}
                className={styles['desktop-only']}
              />

              <h1 className={styles.title}>{t('crypto_loans')}</h1>
              <h2 className={styles.subtitle} dangerouslySetInnerHTML={{
                __html: t('get_instant_funds_against_your_crypto')
              }}></h2>
              <div className={styles['subtitle-text']}>
                <p>{t('access_extra_funds_without_selling_crypto')}</p>
                <p className={styles['desktop-only']}>{t('grow_portfolio')}</p>
              </div>
            </div>

            <div className={styles.advantages}>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('safe')}</p>
                <p className={styles['advantages-text']}>
                  <span className={styles.nowrap}>{t('top_tier_security')},</span>
                  <span>{t('cold_wallet_storage')}</span>
                </p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('easy')}</p>
                <p className={styles['advantages-text']}>
                  <span>{t('no_credit_check')}</span>
                </p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{t('start')}</p>
                <p className={styles['advantages-text']}>{t('from')} $100</p>
              </div>
              <div className={styles['advantages-item']}>
                <p className={styles['advantages-main']}>{currenciesCount}</p>
                <p className={styles['advantages-text']}>{t('currencies')}</p>
              </div>

              <div className={cn(styles['advantages-item'],styles['partner-item'], styles['socials'])}>
                <p className={cn(styles['partner-title'], styles['desktop-only'])}>{t('download_the_app')}</p>
                <MobileAppBtn />         
              </div>
              <div className={cn(styles['advantages-item'], styles['partner-item'], styles['socials'])}>
                <p className={cn(styles['partner-title'], styles['desktop-only'])}>{t('rated_excellent')}</p>
                <p className={styles['advantages-text']}><div id="trustpilot-target" /></p>        
              </div>
            </div>
          </div>

          <div className={styles.calculator}>
            <TabsSlider
              tabs={tabs}
              activeTab={tabs[0]}
              handleTabChange={handleTabChange}
              type={'white'}
              className={styles['mobile-only']} />
            <Calculator />
          </div>
        </div>
      </div>
    </section>
  )
}
